/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Batch } from './Batch';
import {
    BatchFromJSON,
    BatchFromJSONTyped,
    BatchToJSON,
} from './Batch';

/**
 * 
 * @export
 * @interface ListBatchesResponseBody
 */
export interface ListBatchesResponseBody {
    /**
     * 
     * @type {Array<Batch>}
     * @memberof ListBatchesResponseBody
     */
    items: Array<Batch>;
    /**
     * A cursor for use in the subsequent call.
     * @type {string}
     * @memberof ListBatchesResponseBody
     */
    startingAfter?: string;
    /**
     * The total number of items in the collection.
     * @type {number}
     * @memberof ListBatchesResponseBody
     */
    totalCount: number;
}

/**
 * Check if a given object implements the ListBatchesResponseBody interface.
 */
export function instanceOfListBatchesResponseBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "totalCount" in value;

    return isInstance;
}

export function ListBatchesResponseBodyFromJSON(json: any): ListBatchesResponseBody {
    return ListBatchesResponseBodyFromJSONTyped(json, false);
}

export function ListBatchesResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBatchesResponseBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BatchFromJSON)),
        'startingAfter': !exists(json, 'starting_after') ? undefined : json['starting_after'],
        'totalCount': json['total_count'],
    };
}

export function ListBatchesResponseBodyToJSON(value?: ListBatchesResponseBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(BatchToJSON)),
        'starting_after': value.startingAfter,
        'total_count': value.totalCount,
    };
}

